import { Directive, OnInit } from '@angular/core';
import { Select } from 'primeng/select';

/**
 * Workaround for PrimeNG 20.4.0 (ATLAS-5639).
 *
 * Select.applyFocus() still queries the PrimeNG v17 class pair
 * '.p-dropdown-label.p-inputtext' when [editable] is set. The v20 editable input renders as
 * 'p-select-label', so the query returns null and .focus() throws a TypeError, taking the page
 * down. This replaces applyFocus on the host Select instance with one that uses the component's
 * own view children.
 *
 * REMOVE THIS DIRECTIVE (and its two template usages) once PrimeNG ships the upstream fix —
 * verify Select.applyFocus in node_modules/primeng/fesm2022/primeng-select.mjs after upgrading.
 */
@Directive({
  selector: '[wlEditableSelectFocusFix]',
  standalone: false,
})
export class EditableSelectFocusFixDirective implements OnInit {
  constructor(private readonly select: Select) {}

  ngOnInit(): void {
    this.select.applyFocus = () => {
      const target = this.select.editable
        ? this.select.editableInputViewChild
        : this.select.focusInputViewChild;
      target?.nativeElement?.focus({ preventScroll: true });
    };
  }
}
